import { render, staticRenderFns } from "./MatchesOverviewTable.vue?vue&type=template&id=1ccaf9cb&"
import script from "./MatchesOverviewTable.controller.js?vue&type=script&lang=js&"
export * from "./MatchesOverviewTable.controller.js?vue&type=script&lang=js&"
import style0 from "./MatchesOverviewTable.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VRow,VSelect,VSnackbar,VTextField})
